import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';
import { BankListPage, BankCreatePage } from './imports';

export const bankRoutes = [
  {
    path: 'bank',
    children: [
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.CONTACT}
            access={OrionAccess.VIEW}
          >
            <BankListPage />
          </PermissionGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.CONTACT}
            access={OrionAccess.VIEW}
          >
            <BankListPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.CONTACT}
            access={OrionAccess.CREATE}
          >
            <BankCreatePage />
          </PermissionGuard>
        ),
      },

    ],
  },
];
